import { render, staticRenderFns } from "./CampaignViewCpiLimitHint.vue?vue&type=template&id=315b7866"
import script from "./CampaignViewCpiLimitHint.vue?vue&type=script&lang=js"
export * from "./CampaignViewCpiLimitHint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports